import React, { useEffect, useRef, useState } from "react";
import {
  getCountries,
  getStates,
  validatebank,
} from "../redux/bankDetailsSlice";
import {
  Button,
  CardContent,
  Checkbox,
  Chip,
  Container,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { VendorCardTitle } from "../../vendorRegistration/components/steps/vendorReg";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckBoxLabel,
  DocumentLabels,
  SelectSpan,
  StyledOutlineButton,
  VendorCardLabel,
} from "../../vendorRegistration/components/StepMain";
import { Super } from "../../vendorRegistration/components/steps/cardTrial";
import { HighlightOff } from "@mui/icons-material";
import styled from "styled-components";
const Input = styled("input")({
  display: "none",
});
const BankEditComponent = ({
  l_index,
  bank_item,
  register,
  onChange,
  errors,
  clientId,
  is_domestic,
  supportingDoc,
  rtgsDoc,
  cancelledCheque,
  bankStatement,
  passBook,
  setSupportingDoc,
  setRtgsDoc,
  setCancelledCheque,
  setBankStatment,
  setPassBook,
}) => {
  const getDocUrl = (doc) => {
    if (!doc) return null;
    if (doc instanceof File) {
      return URL.createObjectURL(doc);
    }
    if (typeof doc === "string" && doc.startsWith("http")) {
      return doc;
    }
    return doc?.image || doc?.path || null;
  };

  const watchFields = ["rtgs", "bankStatement", "ca"];
  const {
    account_name,
    account_number,
    ifsc_code,
    city,
    state,
    country,
    bankInfo,
    branch_name,
    bank_name,
    swift_code,
    address_line_one,
    is_primary_account,
  } = bank_item;

  const { countries, states } = useSelector((state) => state.bankdetails);
  const [ifscCode, setIfscCode] = useState(ifsc_code);
  const [disableEditBtn, setDisableEditBtn] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(
    branch_name ? true : false
  );
  const [disabled, setDisabled] = useState(is_domestic ? true : false);
  const [onETime, setOneTime] = useState(true);
  const dispatch = useDispatch();
  const Countries = (payload) => {
    dispatch(getCountries(payload));
  };
  const handleChangecountry = (payload) => {
    dispatch(getStates(payload));
  };
  const handleIfscChange = (value) => {
    setIfscCode(value);
    setDisableEditBtn(true);
  };
  const fileInputRef = useRef(null);

  const handleDocsChange = (e) => {
    const { name, files } = e.target;
    // let formData = new FormData();
    // formData.append("file", files[0]);
    // dispatch(GSTdocument(formData)).then((responses) => {
    // const { data } = responses.payload;

    if (name === "passBook") {
      setPassBook(files[0]);
      onChange(
        {
          target: {
            name: "bank_passbook_copy_with_bank_stamp_image_name",
            value: files[0],
          },
        },
        l_index
      );
    }
    if (name === "cancelledCheque") {
      setCancelledCheque(files[0]);
      onChange(
        {
          target: {
            name: "cancelled_cheque_image_name",
            value: files[0],
          },
        },
        l_index
      );
    }
    if (name === "rtgs") {
      setRtgsDoc(files[0]);
      onChange(
        {
          target: {
            name: "rtgs_authorization_letter_image_name",
            value: files[0],
          },
        },
        l_index
      );
    }
    if (name === "bankStatement") {
      setBankStatment(files[0]);
      onChange(
        {
          target: { name: "bank_statement_image_name", value: files[0] },
        },
        l_index
      );
    }
    if (name === "supportingDoc") {
      setSupportingDoc(files[0]);
      onChange(
        {
          target: {
            name: "supporting_document_image_name",
            value: files[0],
          },
        },
        l_index
      );
    }
    // });
  };

  const onDocRemove = (name) => {
    if (name === "passBook") {
      setPassBook("");

      onChange(
        {
          target: {
            name: "bank_passbook_copy_with_bank_stamp_image_name",
            value: { action: "remove" },
          },
        },
        l_index
      );
    }
    if (name === "cancelledCheque") {
      setCancelledCheque("");
      onChange(
        {
          target: {
            name: "cancelled_cheque_image_name",
            value: { action: "remove" },
          },
        },
        l_index
      );
    }
    if (name === "rtgs") {
      setRtgsDoc("");
      onChange(
        {
          target: {
            name: "rtgs_authorization_letter_image_name",
            value: { action: "remove" },
          },
        },
        l_index
      );
    }
    if (name === "bankStatement") {
      setBankStatment("");
      onChange(
        {
          target: {
            name: "bank_statement_image_name",
            value: { action: "remove" },
          },
        },
        l_index
      );
    }
    if (name === "supportingDoc") {
      setSupportingDoc("");
      onChange(
        {
          target: {
            name: "supporting_document_image_name",
            value: { action: "remove" },
          },
        },
        l_index
      );
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const validateBank = () => {
    dispatch(validatebank({ ifsc: ifsc_code ?? ifscCode })).then((response) => {
      if (response.payload.success) {
        setDisabled(false);
        setShowBankDetails(true);
        const { data } = response.payload;
        onChange(
          {
            target: {
              name: "address_line_one",
              value: data?.address,
            },
          },
          l_index
        );
        onChange(
          {
            target: {
              name: "bank_name",
              value: data?.bank,
            },
          },
          l_index
        );
        onChange(
          {
            target: {
              name: "branch_name",
              value: data?.branch,
            },
          },
          l_index
        );
        onChange(
          {
            target: {
              name: "swift_code",
              value: data?.swiftCode,
            },
          },
          l_index
        );
        onChange(
          {
            target: {
              name: "city",
              value: data?.city,
            },
          },
          l_index
        );
        onChange(
          {
            target: {
              name: "state",
              value: data?.state,
            },
          },
          l_index
        );
      }
    });
  };
  const hasError = (field, value) => {
    if (field === "cancelledCheque") {
      return (
        Boolean(errors?.cancelledCheque) &&
        cancelledCheque === "" &&
        rtgsDoc === "" &&
        bankStatement === ""
      );
    }
    if (field === "rtgs") {
      return (
        Boolean(errors?.rtgs) &&
        rtgsDoc === "" &&
        cancelledCheque === "" &&
        bankStatement === ""
      );
    }
    if (field === "bankStatement") {
      return (
        Boolean(errors?.bankStatement) &&
        bankStatement === "" &&
        cancelledCheque === "" &&
        rtgsDoc === ""
      );
    }
    return false;
  };
  console.log("chequeUrl")
  useEffect(() => {
    Countries();
  }, []);
  return (
    <div>
      <CardContent>
        <Container fixed>
          <Grid>
            <VendorCardTitle>Payment Information</VendorCardTitle>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <VendorCardLabel>
                A/C Holder name <Super>*</Super>
              </VendorCardLabel>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                InputProps={{
                  disableUnderline: false,
                  disableInjectingGlobalStyles: true,
                }}
                InputLabelProps={{
                  disableAnimation: true,
                  disableInjectingGlobalStyles: true,
                }}
                placeholder="Enter name of account"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="account_name"
                {...register("account_name", {
                  value: account_name,
                  required: "Please enter A/C holder name",
                })}
                error={Boolean(errors?.account_name)}
                helperText={errors.account_name?.message}
                value={account_name ?? ""}
                onChange={(e) => onChange(e, l_index)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <VendorCardLabel>
                {is_domestic ? "Account Number" : "IBA Number"}
                <Super>*</Super>
              </VendorCardLabel>
              <TextField
                sx={{
                  input: {
                    fontSize: "14px",
                    fontFamily: "var(--font-family-reg)",
                  },
                }}
                InputProps={{
                  disableUnderline: false,
                  disableInjectingGlobalStyles: true,
                }}
                InputLabelProps={{
                  disableAnimation: true,
                  disableInjectingGlobalStyles: true,
                }}
                placeholder="Enter account number"
                size="small"
                variant="standard"
                style={{ width: "100%", paddingTop: "3px" }}
                name="account_number"
                {...register("account_number", {
                  pattern: {
                    value: /-?\d*\.?\d{1,2}/,
                    message: "Invalid account number",
                  },
                  required: "Please Enter account number",
                  value: account_number ?? "",
                })}
                error={Boolean(errors?.account_number)}
                helperText={errors.account_number?.message}
                value={account_number}
                onChange={(e) => onChange(e, l_index)}
              />
            </Grid>

            {is_domestic && (
              <>
                <Grid item xs={12} sm={6} md={6}>
                  <VendorCardLabel>
                    IFSC Code <Super>*</Super>
                  </VendorCardLabel>
                  <TextField
                    sx={{
                      input: {
                        fontSize: "14px",
                        fontFamily: "var(--font-family-reg)",
                      },
                    }}
                    InputProps={{
                      disableUnderline: false,
                      disableInjectingGlobalStyles: true,
                    }}
                    InputLabelProps={{
                      disableAnimation: true,
                      disableInjectingGlobalStyles: true,
                    }}
                    placeholder="Enter IFSC Code"
                    size="small"
                    variant="standard"
                    style={{ width: "100%", paddingTop: "3px" }}
                    name="ifsc_code"
                    {...register("ifsc_code", {
                      value: ifsc_code ?? ifscCode,
                      pattern: {
                        value: /^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$/,
                        message: "Please Enter valid IFSC",
                      },
                      required: "Please enter IFSC",
                    })}
                    onChange={(e) => {
                      handleIfscChange(e.target.value);
                      onChange(e, l_index);
                    }}
                    error={Boolean(errors?.ifsc_code)}
                    value={ifsc_code ?? ifscCode}
                    helperText={errors.ifsc_code?.message}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Button
                    variant="contained"
                    sx={{ width: "150px", marginTop: "10px" }}
                    onClick={(e) => validateBank(e)}
                  >
                    Validate IFSC
                  </Button>
                </Grid>
                {branch_name && (
                  <>
                    <Grid item xs={12} sm={6} md={6}>
                      <VendorCardLabel>
                        Bank Name<Super>*</Super>
                      </VendorCardLabel>
                      <span>
                        <b>{bank_name}</b>
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <VendorCardLabel>
                        Branch Name<Super>*</Super>
                      </VendorCardLabel>
                      <span>
                        <b>{branch_name}</b>
                      </span>
                    </Grid>

                    <br />

                    <Grid item xs={12} sm={6} md={6}>
                      <VendorCardLabel>
                        Address line 1<Super>*</Super>
                      </VendorCardLabel>
                      <span>
                        <b>{address_line_one}</b>
                      </span>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </Container>
      </CardContent>

      <CardContent>
        <Container fixed>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <VendorCardTitle>Supporting Documents</VendorCardTitle>
            </Grid>
            <Grid item xs={6} md={6}></Grid>
          </Grid>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload cancelled cheque <Super>*</Super>
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={hasError(errors?.cancelledCheque)}
              >
                {cancelledCheque !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      {(() => {
                        const chequeUrl = getDocUrl(cancelledCheque);
                        console.log("chequeUrl", chequeUrl)
                        return (
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={cancelledCheque?.name || (cancelledCheque instanceof File ? cancelledCheque.name : cancelledCheque)}
                            value={cancelledCheque?.name}
                            name="chips"
                            {...(chequeUrl
                              ? {
                                component: "a",
                                clickable: true,
                                href: chequeUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              }
                              : {})}
                          />
                        );
                      })()}
                      <HighlightOff
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={() => onDocRemove("cancelledCheque")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="cancelledCheque">
                    <Input
                      {...register("cancelledCheque", {
                        required:
                          clientId === 2 || clientId === 5
                            ? false
                            : "Please upload cancelled cheque copy",
                      })}
                      accept="*"
                      id="cancelledCheque"
                      name="cancelledCheque"
                      onChange={handleDocsChange}
                      ref={fileInputRef}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                    <span>{cancelledCheque.name}</span>
                  </label>
                )}
                {hasError("cancelledCheque", cancelledCheque) ? (
                  <FormHelperText>
                    {errors.cancelledCheque?.message}
                  </FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>
          {clientId !== 3 ? (
            <p style={{ textAlign: "center", width: "50%" }}>OR</p>
          ) : (
            ""
          )}

          <br />
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  {clientId === 2 ? (
                    <>
                      Bank Mandate duly stamped showing Account & RTGS details
                      <Super>*</Super>
                    </>
                  ) : (
                    <>
                      Upload RTGS authorization letter
                      <Super>*</Super>
                    </>
                  )}
                </DocumentLabels>
              </span>
            </Grid>

            <Grid item xs={6}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={hasError(errors?.rtgs)}
              >
                {rtgsDoc !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      {(() => {
                        const rtgsUrl = getDocUrl(rtgsDoc);
                        return (
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={rtgsDoc?.name || (rtgsDoc instanceof File ? rtgsDoc.name : rtgsDoc)}
                            value={rtgsDoc?.name}
                            name="chips"
                            {...(rtgsUrl
                              ? {
                                component: "a",
                                clickable: true,
                                href: rtgsUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              }
                              : {})}
                          />
                        );
                      })()}
                      <HighlightOff
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={() => onDocRemove("rtgs")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="rtgs">
                    <Input
                      {...register("rtgs")}
                      accept="*"
                      id="rtgs"
                      onChange={handleDocsChange}
                      ref={fileInputRef}
                      type="file"
                    />

                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
                {hasError("rtgs", rtgsDoc) ? (
                  <FormHelperText>{errors.rtgs?.message}</FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>
          {clientId === 2 || clientId === 5 ? (
            <p style={{ textAlign: "center", width: "50%" }}>OR</p>
          ) : (
            ""
          )}
          <br />

          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload bank statement
                  {clientId === 2 || clientId === 5 ? <Super>*</Super> : ""}
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={hasError("bankStatement", bankStatement)}
              >
                {bankStatement !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      {(() => {
                        const bankStatementUrl = getDocUrl(bankStatement);
                        return (
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={bankStatement?.name || (bankStatement instanceof File ? bankStatement.name : bankStatement)}
                            value={bankStatement?.name}
                            name="chips"
                            {...(bankStatementUrl
                              ? {
                                component: "a",
                                clickable: true,
                                href: bankStatementUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              }
                              : {})}
                          />
                        );
                      })()}
                      <HighlightOff
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={() => onDocRemove("bankStatement")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="bankStatement">
                    <Input
                      {...register("bankStatement")}
                      accept="*"
                      id="bankStatement"
                      name="bankStatement"
                      onChange={handleDocsChange}
                      ref={fileInputRef}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                    <span>{bankStatement.name}</span>
                  </label>
                )}
                {hasError("bankStatement", bankStatement) ? (
                  <FormHelperText>
                    {errors.bankStatement?.message}
                  </FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <br />
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>
                  Upload bank passbook copy with bank stamp
                </DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              {passBook !== "" ? (
                <>
                  <span
                    style={{
                      color: "#4945FF",
                      fontSize: "13px",
                      fontFamily: "var(--font-family-reg)",
                    }}
                  >
                    {(() => {
                      const passBookUrl = getDocUrl(passBook);
                      return (
                        <Chip
                          style={{
                            width: "150px",
                            color: "#4945FF",
                            margin: "5px",
                            borderRadius: "5px",
                            border: "1px solid #D9D8FF",
                            background: "#F0F0FF",
                          }}
                          label={passBook?.name || (passBook instanceof File ? passBook.name : passBook)}
                          value={passBook?.name}
                          name="chips"
                          {...(passBookUrl
                            ? {
                              component: "a",
                              clickable: true,
                              href: passBookUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            }
                            : {})}
                        />
                      );
                    })()}
                    <HighlightOff
                      sx={{ color: "#4945FF", paddingBottom: "2px" }}
                      fontSize="medium"
                      onClick={() => onDocRemove("passBook")}
                    />
                  </span>
                </>
              ) : (
                <label htmlFor="passBook">
                  <Input
                    accept="*"
                    id="passBook"
                    name="passBook"
                    onChange={handleDocsChange}
                    ref={fileInputRef}
                    type="file"
                  />
                  <StyledOutlineButton variant="outlined" component="span">
                    Upload
                  </StyledOutlineButton>
                  <span>{passBook.name}</span>
                </label>
              )}
            </Grid>
          </Grid>
          <br />
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={6}>
              <span
                variant="outlined"
                component="span"
                style={{ width: "50%" }}
              >
                <DocumentLabels>Upload supporting document</DocumentLabels>
              </span>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard" style={{ width: "100%" }}>
                {supportingDoc !== "" ? (
                  <>
                    <span
                      style={{
                        color: "#4945FF",
                        fontSize: "13px",
                        fontFamily: "var(--font-family-reg)",
                      }}
                    >
                      {(() => {
                        const supportingDocUrl = getDocUrl(supportingDoc);
                        return (
                          <Chip
                            style={{
                              width: "150px",
                              color: "#4945FF",
                              margin: "5px",
                              borderRadius: "5px",
                              border: "1px solid #D9D8FF",
                              background: "#F0F0FF",
                            }}
                            label={supportingDoc?.name || (supportingDoc instanceof File ? supportingDoc.name : supportingDoc)}
                            value={supportingDoc?.name}
                            name="chips"
                            {...(supportingDocUrl
                              ? {
                                component: "a",
                                clickable: true,
                                href: supportingDocUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              }
                              : {})}
                          />
                        );
                      })()}
                      <HighlightOff
                        sx={{ color: "#4945FF", paddingBottom: "2px" }}
                        fontSize="medium"
                        onClick={() => onDocRemove("supportingDoc")}
                      />
                    </span>
                  </>
                ) : (
                  <label htmlFor="supportingDoc">
                    <Input
                      {...register("supportingDoc", {
                        required: false,
                      })}
                      accept="*"
                      id="supportingDoc"
                      onChange={handleDocsChange}
                      ref={fileInputRef}
                      type="file"
                    />
                    <StyledOutlineButton variant="outlined" component="span">
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <br />
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  color: "lightgray",
                  "&.Mui-checked": {
                    color: "#4059e5",
                  },
                }}
                name="is_primary_account"
                value={is_primary_account}
                onChange={(e) => onChange(e, l_index)}
              />
            }
            label={
              <CheckBoxLabel>Make this my primary bank account</CheckBoxLabel>
            }
          />
          {watchFields.filter(Boolean).length === 0 && (
            <p>Please select at least one image.</p>
          )}
        </Container>
      </CardContent>
    </div>
  );
};

export default BankEditComponent;
